<script setup lang="ts">
import { ref } from "vue";
import ColumnLayout from "@/shared/components/ColumnLayout/ColumnLayout.vue";
import ColumnLayoutBox from "@/shared/components/ColumnLayoutBox/ColumnLayoutBox.vue";
import RegistrationFormContainer from "@/app/registration-app/user/invited-registration/containers/RegistrationFormContainer/RegistrationFormContainer.vue";
import type { Message } from "@/app/registration-app/user/invited-registration/@types/Message";
import StatusMessagePage from "@/app/registration-app/shared/components/StatusMessagePage/StatusMessagePage.vue";
import { RegistrationType } from "@/shared/generated/graphql";

withDefaults(
  defineProps<{
    provisioningKey: string;
    registrationType?: RegistrationType;
  }>(),
  {
    registrationType: RegistrationType.Email,
  },
);

// --- Message ---
const messageTitle = ref("");
const messageText = ref<string | undefined>(undefined);
const messageSubText = ref<string | undefined>(undefined);
const showMessage = (message: Message) => {
  messageTitle.value = message.title;
  messageText.value = message.text;
  messageSubText.value = message.subText;
};
</script>

<template>
  <StatusMessagePage
    v-if="messageTitle"
    :title="messageTitle"
    :text="messageText"
    :sub-text="messageSubText"
  />
  <StatusMessagePage
    v-else-if="!provisioningKey"
    :title="$t('registration.user.invited.error.invalidLink.title')"
    :text="$t('registration.user.invited.error.invalidLink.text')"
  />
  <ColumnLayout v-else>
    <template #column1>
      <ColumnLayoutBox center-content="both">
        <RegistrationFormContainer
          :provisioning-key="provisioningKey"
          :registration-type="registrationType"
          @show-message="showMessage"
          @show-success="
            showMessage({
              title: $t('registration.user.invited.success.title'),
              text: $t('registration.user.invited.success.text'),
            })
          "
        />
      </ColumnLayoutBox>
    </template>
  </ColumnLayout>
</template>
